<script>
import { headerCartProps } from "./mixin";
import Button from "@/components/atoms/button";
import Icon from "@/components/atoms/icon";

export default {
  name: "Cart",
  components: { Button, Icon },
  props: {
    ...headerCartProps()
  }
};
</script>

<template>
  <Button
    variant="secondary"
    size="md"
    radius="full"
    class="c-header-cart"
    v-bind="extractListenersFromAttrs($attrs)"
  >
    <Icon
      name="cart"
      class="c-header-cart__icon-cart"
      variant="white"
      size="sm"
    />
    <div class="c-header-cart__total">
      <ClientOnly>
        <span v-show="!isLoading">
          {{ formatPrix(total) }}&nbsp;€
        </span>
      </ClientOnly>
      <ClientOnly>
        <svg
          v-show="isLoading"
          width="20"
          height="20"
          viewBox="0 0 38 38"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient
              id="a"
              x1="8.042%"
              y1="0%"
              x2="65.682%"
              y2="23.865%"
            >
              <stop
                stop-color="#fff"
                stop-opacity="0"
                offset="0%"
              />
              <stop
                stop-color="#fff"
                stop-opacity=".631"
                offset="63.146%"
              />
              <stop
                stop-color="#fff"
                offset="100%"
              />
            </linearGradient>
          </defs>
          <g
            fill="none"
            fill-rule="evenodd"
          >
            <g transform="translate(1 1)">
              <path
                id="Oval-2"
                d="M36 18c0-9.94-8.06-18-18-18"
                stroke="url(#a)"
                stroke-width="2"
              >
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  from="0 18 18"
                  to="360 18 18"
                  dur="0.9s"
                  repeatCount="indefinite"
                />
              </path>
              <circle
                fill="#fff"
                cx="36"
                cy="18"
                r="1"
              >
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  from="0 18 18"
                  to="360 18 18"
                  dur="0.9s"
                  repeatCount="indefinite"
                />
              </circle>
            </g>
          </g>
        </svg>
      </ClientOnly>
      <Icon
        name="arrow-down"
        class="c-header-cart__icon-arrow"
        variant="white"
        size="xs"
      />
    </div>
  </Button>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/header-cart.scss";
</style>
